import { CertificateOwnership, CheckboxMapping } from '../types'
import { SetStateAction } from 'react'

export const isChecked = (checkboxMappings: CheckboxMapping[], id?: number) => {
    if (id) {
        return (
            checkboxMappings.find((mapping: CheckboxMapping) => mapping.id === id)?.checked ?? false
        )
    }
    return false
}

export const toggleCheckbox = (
    setMappings: (value: SetStateAction<CheckboxMapping[]>) => void,
    record: CertificateOwnership,
    checked: boolean,
) => {
    if (record) {
        const id = record.id
        setMappings((prev) => prev.map((m) => (m.id === id ? { ...m, checked } : m)))
    }
}
